/* Build article TOC from semantic headings; no article-body edits. */
(function(){
function init(){
 document.querySelectorAll('.hb-editorial').forEach(function(root){
  var content=root.querySelector('.tt-post-content'), toc=root.querySelector('.hb-toc');
  if(!content||!toc||toc.dataset.ready)return;
  var headings=Array.from(content.querySelectorAll('h2,h3')).filter(function(h){return h.textContent.trim().length>0;});
  if(headings.length<2){toc.remove();return;}
  var list=document.createElement('ol');list.className='hb-toc-list';
  headings.forEach(function(h,i){
   if(!h.id){var id='hb-section-'+(i+1),suffix=1;while(document.getElementById(id)){id='hb-section-'+(i+1)+'-'+suffix++;}h.id=id;}
   var li=document.createElement('li');/* Sequential numeric list, matching editorial reference. */
   var a=document.createElement('a');a.href='#'+encodeURIComponent(h.id);a.textContent=h.textContent.trim();
   li.appendChild(a);list.appendChild(li);
  });
  toc.appendChild(list);toc.dataset.ready='1';toc.hidden=false;
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();